import { r2Fetch } from './client';

export interface R2BucketTreeParams {
  bucket_id: string;
  prefix?: string;
}

export interface R2BucketTreeItem {
  path: string;
  type: 'file' | 'directory';
  size?: number;
  etag?: string;
  uploaded?: string;
}

export interface R2BucketTreeResponse {
  tree: R2BucketTreeItem[];
}

export async function r2BucketTree(
  params: R2BucketTreeParams
): Promise<R2BucketTreeResponse> {
  return r2Fetch<R2BucketTreeResponse>('/rpc/r2_bucket_tree', {
    body: params,
  });
}
